import Autoplay from 'embla-carousel-autoplay';
import { classes } from 'html-classes';
import { useCallback, useRef, useState } from 'react';

import {
  Carousel,
  type CarouselApi,
  CarouselContent,
  CarouselItem,
} from '../Carousel/Carousel';
import type { BannerCarouselDesktopProps } from '../Carousel/interfaces';
import { IconButton } from '../IconButton';

import styles from './BannerCarouselDesktop.module.scss';

const BannerCarouselDesktop = ({
  items,
  slidesPerView = 1,
  showArrows = true,
  className,
  ...props
}: BannerCarouselDesktopProps) => {
  const [api, setApi] = useState<CarouselApi | null>(null);
  const autoplay = useRef(Autoplay({ delay: 5000, stopOnInteraction: false }));
  const shouldLoop = items.length > slidesPerView;

  const scrollPrev = useCallback(() => {
    api?.scrollPrev();
  }, [api]);

  const scrollNext = useCallback(() => {
    api?.scrollNext();
  }, [api]);

  return (
    <div {...props} className={classes([styles.container, className])}>
      {showArrows && (
        <IconButton
          className={styles.carouselIconPrev}
          icon="chevron-3.1"
          iconSize={14}
          onClick={scrollPrev}
          size="XL"
          variant="shadowS"
        />
      )}
      <Carousel
        opts={{
          loop: shouldLoop,
          align: 'start',
          active: items.length > 2,
          slidesToScroll: 1,
        }}
        plugins={[autoplay.current]}
        setApi={setApi}
        className={styles.carousel}
      >
        <CarouselContent className={styles.carouselContent}>
          {items.map((item) => (
            <CarouselItem
              key={item.id}
              className={styles.slide}
              style={{
                maxWidth: slidesPerView === 1 ? '100%' : '50%',
              }}
            >
              {item.node}
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
      {showArrows && (
        <IconButton
          className={styles.carouselIconNext}
          icon="chevron-3.1"
          iconSize={14}
          onClick={scrollNext}
          size="XL"
          variant="shadowS"
        />
      )}
    </div>
  );
};

export default BannerCarouselDesktop;
